module.exports = __webpack_public_path__ + "static/img/door-1.6f5ee71b.png";